const showMoreThreshold = {
  category: 10,
  tags: 12,
  compatible_with: 12,
  platform: 12,
  file_formats: 12
}

export { showMoreThreshold }
